import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 4v4c-6.575 1.028 -9.02 6.788 -10 12c-.037 .206 5.384 -5.962 10 -6v4l8 -7l-8 -7","key":"svg-0"}]]

/**
 * IconShare3
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc2hhcmUtMyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTMgNHY0Yy02LjU3NSAxLjAyOCAtOS4wMiA2Ljc4OCAtMTAgMTJjLS4wMzcgLjIwNiA1LjM4NCAtNS45NjIgMTAgLTZ2NGw4IC03bC04IC03IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/share-3
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconShare3 = createReactComponent('outline', 'share-3', 'Share3', __iconNode);

export default IconShare3;